import React from 'react'
import { Col, Row, Typography } from 'antd'

const { Title } = Typography

const Home = () => {
    return (
        <>
            <Row>
                <Col>
                    <Title level={3}>Dashboard</Title>
                </Col>
            </Row>
        </>
    )
}

export default Home